import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { providerColumns } from './provider-columns';
import messages from './use-provider-columns-messages';

const buildColumnOrder = (additionalHeaders) => {
  const standardColumns = [providerColumns.NAME, providerColumns.STATUS, providerColumns.ACTIONS];

  const addColumn = (column, place) => standardColumns.splice(place, 0, column);

  addColumn(providerColumns.SHARED_SERVICES, 2);
  addColumn(providerColumns.PACKING_SLIP_SHARING, standardColumns.length - 1);

  if (additionalHeaders?.length) {
    additionalHeaders.forEach((header) => {
      addColumn(header.column, header.place);
    });
  }

  return standardColumns;
};

export const useProviderReactTableColumns = (additionalHeaders, componentFactory, headersFactory) => {
  const intl = useIntl();

  const columns = useMemo(() => {
    const orderedColumnKeys = buildColumnOrder(additionalHeaders);

    return orderedColumnKeys.map((columnKey) => {
      const title = intl.formatMessage(messages[columnKey]);

      const HeaderComponent = headersFactory?.[columnKey];
      const Header = HeaderComponent ? <HeaderComponent title={title} /> : title;

      const Cell = ({ value }) => {
        const Component = componentFactory?.factory?.[columnKey];
        if (!Component) {
          return value ?? null;
        }
        return <Component {...componentFactory.props} provider={value} />;
      };

      return {
        accessor: columnKey,
        Header,
        Cell,
      };
    });
  }, [additionalHeaders, intl, componentFactory, headersFactory]);

  return columns;
};
